import { useContext } from "react";
import AllProduct from "./AllProduct";
import UserContext from "../context/UserContext";

function FeaturedProducts() {
  const {products} = useContext(UserContext)

  
  return (
    <div className="third">
      <div className="third-con">
        <h1>Featured Products</h1>
        <AllProduct items={products} />
        <br />
        <br />
      </div>
    </div>
  );
}

export default FeaturedProducts;
